module.exports = __webpack_public_path__ + "img/Logo_sx.adedca87.png";